import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { preloadPageTranslations } from "../../i18n";

export const withTranslations =
  (namespace: string) =>
  <P extends object>(WrappedComponent: React.ComponentType<P>) => {
    return function WithTranslationsComponent(props: P) {
      const [isLoading, setIsLoading] = useState(true);
      const { i18n } = useTranslation();

      useEffect(() => {
        const loadTranslations = async () => {
          setIsLoading(true);
          await preloadPageTranslations(namespace);
          // Force a re-render after translations are loaded
          await i18n.reloadResources();
          setIsLoading(false);
        };

        loadTranslations();
      }, [i18n.language]);

      if (isLoading) {
        return (
          <div className="flex items-center justify-center min-h-[200px]">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
          </div>
        );
      }

      return <WrappedComponent {...props} />;
    };
  };
